import { QueryClient } from "@tanstack/react-query";

/**
 * Cost is rates × counts at read time, so every cost figure already on screen
 * is stale the moment a rate changes.
 */
export const invalidatePricing = (queryClient: QueryClient) => {
  for (const key of ["meta-rates", "org-kpis", "orgs-overview", "org-nodes"]) {
    queryClient.invalidateQueries({ queryKey: [key] });
  }
};
